import { Pipe, PipeTransform } from '@angular/core';
import { CatalogCategory } from 'src/app/provider/catalogue.service';
import { CaptionMlPipe } from './caption-ml.pipe';
import { CaptionPipe } from './caption.pipe';
@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  constructor(private translate: CaptionPipe) { }

  transform(catalogs: CatalogCategory[], search: string): CatalogCategory[] {
    let result: CatalogCategory[] = [];



    if (search) {
      search = search.toLowerCase();
      result = catalogs.filter((catalog) => {
        let name = this.translate.transform(catalog.category.name);
        name = name.toLowerCase();
        return name.includes(search);
      });

      return result;
    } else {
      return catalogs;
    }

  }

}
